<template>
	<a :href="href != null ? href : $router.path" :style="empty ? 'opacity: 0.7' : ''">
		<div v-if="isAddButton">
			<v-row>
				<v-col>
					<img class="plusIcon" src="../../assets/VouchersEmptyState.png" />
				</v-col>
			</v-row>
		</div>
		<div class="account-summary-button" v-if="!isAddButton">
			<v-row>
				<v-col class="title-col">
					<span class="nowrap bold">{{ title }}</span>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<img class="icon" :src="icon" :style="getIconStyle()" />
				</v-col>
			</v-row>
			<v-row class="mt-0" v-if="dateTime">
				<v-col>
					<span class="dateTimeLabel nowrap">{{ dateTime }}</span>
				</v-col>
			</v-row>
			<v-row class="mt-0" v-if="showProvider">
				<v-col>
					<span class="providerLabel nowrap">{{ provider || '\u00A0' }}</span>
				</v-col>
			</v-row>
			<v-row v-if="voucherCount > 0">
				<v-col v-if="voucherCount > 1">
					<span class="voucherCountLabel nowrap">{{ voucherCount }} Vouchers</span>
				</v-col>
				<v-col v-else>
					<span class="voucherCountLabel nowrap">Voucher</span>
				</v-col>
			</v-row>
			<v-row class="mt-0" v-if="showBalance">
				<v-col class="v-col-7 balanceCol">
					<span class="balanceLabel nowrap">{{ balance }}</span>
				</v-col>
				<v-col class="arrow-col">
					<img class="arrow" src="../../assets/arrow-right.png">
				</v-col>
			</v-row>
		</div>
	</a>
</template>

<script>
export default {
	name: "AccountButton",
	props: {
		title: String,
		icon: String,
		provider: String,
		balance: String,
		circleIcon: Boolean,
		isAddButton: Boolean,
		href: String,
		empty: Boolean,
		showProvider: {
			type: Boolean,
			default: true
		},
		showBalance: {
			type: Boolean,
			default: true
		},
		voucherCount: {
			type: Number,
			default: 0
		},
		dateTime: String
	},
	data() {
		return{
			
		}
	},
	methods: {
		onLoad() {
		},
		getIconStyle() {
			if (this.circleIcon) {
				return null;
			} else {
				return {
					width: '72px',
					height: '48px',
					borderRadius: '5px'
				};
			}
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

.account-summary-button, .account-add-button {
	border-radius: 8px;
	padding: 18px;
	border-color: var(--border-color);
	border: 0px solid var(--border-color);
	height: 100%;
	background-color: var(--background-color);
	width: 100%;
}

.plusIcon {
	width: 158px;
	height: 180px;
	margin-top: 10px;
}

.title-col {
	font-size: 16px;
	span {
		text-wrap: nowrap;
		overflow: ellipsis;
		display: block;
	}
}

.icon {
	width: 40px;
	height: 40px;
	background: linear-gradient(230deg, #E7ECF7 16.24%, #EAEDFF 84.93%);
	border-radius: 50%;
}

.arrow-col {
	text-align: right;
	padding-left: 0px;
}

.arrow {
	width: 18px;
}

.providerLabel {

}

.balanceCol {
	padding-right: 0px;
}

.balanceLabel {
	font-size: 15px;
	font-weight: bold;
}

.voucherCountLabel {
	font-size: 13px;
	margin-bottom: -12px;
}

</style>